module.exports = __webpack_public_path__ + "static/media/lina.1dc07df2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials/lina.png
// module id = 1435
// module chunks = 0